export const SwiperButtonPrev = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="20" cy="20" r="20" transform="rotate(-180 20 20)" fill="#707E95" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.2859 13.7204C22.0284 13.4354 21.5809 13.4357 21.324 13.7211L15.8225 19.8309C15.48 20.2112 15.48 20.7888 15.8225 21.1691L21.267 27.2156C21.5545 27.5349 22.0549 27.5353 22.3429 27.2165C22.592 26.9407 22.592 26.5211 22.3429 26.2453L17.4556 20.8352C17.2837 20.6448 17.2837 20.3552 17.4556 20.1648L22.2859 14.8178C22.5674 14.5061 22.5674 14.032 22.2859 13.7204Z"
				fill="white"
			/>
		</svg>
	)
}
